(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-carousel"] && !Shopify.designMode) return;
  try {
    
  const scrollContainer = document.querySelector(".component-content-wrapper");
  const btnLeft = document.getElementById("scroll-left");
  const btnRight = document.getElementById("scroll-right");
  const counter = document.getElementById("slide-counter");

  const slides = scrollContainer.querySelectorAll(".promo-card-wrapper");
  const totalSlides = slides.length;
  let currentIndex = 1;

  // Init counter
  counter.textContent = `${currentIndex} / ${totalSlides}`;

  // Update counter on scroll
  function updateCounter() {
    const containerCenter = scrollContainer.scrollLeft + scrollContainer.offsetWidth / 2;
    slides.forEach((slide, index) => {
      const slideLeft = slide.offsetLeft;
      const slideRight = slide.offsetLeft + slide.offsetWidth;
      if (containerCenter >= slideLeft && containerCenter < slideRight) {
        currentIndex = index + 1;
        counter.textContent = `${currentIndex} / ${totalSlides}`;
      }
    });
  }

  // Helper: get one card width (including margin/gap)
  function getSlideWidth() {
    const firstSlide = slides[0];
    if (!firstSlide) return 0;
    const style = getComputedStyle(firstSlide);
    const marginRight = parseInt(style.marginRight) || 0;
    return firstSlide.offsetWidth + marginRight;
  }

  // Scroll buttons (always one card)
  btnLeft.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: -getSlideWidth(), behavior: "smooth" });
  });

  btnRight.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: getSlideWidth(), behavior: "smooth" });
  });

  // Keep counter updated
  scrollContainer.addEventListener("scroll", updateCounter);

  // Recalculate if window is resized
  window.addEventListener("resize", () => {
    updateCounter();
  });

  } catch(e) { console.error(e); }
})();
})();
